<template>
<div class="bg-is-red">
  <div class="d-flex flex-nowrap" style="max-width:1580px; margin:0 auto; width:100%;">
    <div class="best-title">Best<br>Property<br>Here</div>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="(row, index) in rows" :key="index">
        <div class="img-div">
          <a v-if="row.for_sale" :href="'/sale/'+row.slug"><img class="best-deals-img" :src="row.featured_photo.thumb.url" :alt="row.id"></a>
          <a v-else-if="row.for_rent" :href="'/rent/'+row.slug"><img class="best-deals-img" :src="row.featured_photo.thumb.url" :alt="row.id"></a>
          <a v-else-if="row.for_auction" :href="'/auction/'+row.slug"><img class="best-deals-img" :src="row.featured_photo.thumb.url" :alt="row.id"></a>
        </div>

        <div v-if="row.for_sale" class="p-0 text-left text-div">
          <div class="best-deals-text text-capitalize" style="font-weight:500;font-size:14px;">
						<span v-if="row.sale_usp">[{{row.sale_usp.toLowerCase()}}]</span>
						{{row.project.toLowerCase()}}
					</div>
          <div class="best-deals-text" style="font-size:10px;line-height:18px;">For Sale</div>
          <div v-if="row.sale_selling_price" class="best-deals-text">RM{{addComma(row.sale_selling_price)}}</div>
        </div>

        <div v-else-if="row.for_rent" class="p-0 text-left text-div">
          <div class="best-deals-text text-capitalize" style="font-weight:500;font-size:14px;">
						<span v-if="row.rent_usp">[{{row.rent_usp.toLowerCase()}}]</span>
						{{row.project.toLowerCase()}}
					</div>
          <div class="best-deals-text" style="font-size:10px;line-height:18px;">For Rent</div>
          <div v-if="row.monthly_rental_price" class="best-deals-text">RM{{addComma(row.monthly_rental_price)}}</div>
        </div>
        
        <div v-else-if="row.for_auction" class="p-0 text-left text-div">
          <div class="best-deals-text text-capitalize" style="font-weight:500;font-size:14px;">
						<span v-if="row.auction_usp">[{{row.auction_usp.toLowerCase()}}]</span>
						{{row.project.toLowerCase()}}
					</div>
          <div class="best-deals-text" style="font-size:10px;line-height:18px;">For Auction</div>
          <div v-if="row.auction_reserve_price" class="best-deals-text">RM{{addComma(row.auction_reserve_price)}}</div>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

  export default {
    name: "best-deals",
    components: {
      Swiper,
      SwiperSlide
    },
    props: ['properties'],
    data() {
      return {
        rows: [],
        isloaded: false,
        swiperOption: {
          direction: 'horizontal',
          slidesPerView: 6,
          spaceBetween: 5,
          mousewheel: true,
          loop: true,
          initialSlide: 0,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          /* pagination: {
            el: '.swiper-pagination',
            clickable: true
          }, */
          breakpoints: {
            1200: {
              slidesPerView: 6,
            },
            1050: {
              slidesPerView: 5,
            },
            901: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 3,
            },
            570: {
              slidesPerView: 2,
            },
            320: {
              slidesPerView: 1.5,
            }
          }
        }
      };
    },
    mounted() {
      this.rows = this.properties;
      this.isloaded = true;
    },
    methods: {
      addComma: function (num) {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      },
    }
  };
</script>

<style scoped lang='scss'>
.bg-is-red {
    background: var(--p4surface2, #F3F3F3);
    width: 100%;
    padding: 10px 10px 0 10px;
}

.img-div {
    padding: 0 10px;
}

.text-div {
    width: calc(100% - 80px);
}

.best-title {
    width: 90px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    display: flex;
    align-items: center;
    padding: 5px 0 5px 20px;
    background: var(--p4redsurface1, #D80000);
    color: var(--p4surface1, #FFFFFF);
    height: 80px;
    border-radius: 6px 0 0 6px;
}

.best-deals-img {
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 2px;
}

.swiper {
    height: 80px;
    width: calc(100% - 90px);
    background: var(--p4redsurface1, #D80000);
    border-radius: 0 6px 6px 0;
}

.swiper-slide {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    width: 100%;
    color: white;
    letter-spacing: 0;
    transition: all 0.3s;
}

.swiper-slide:hover {
    background: rgb(219, 77, 77);
}

.swiper-slide+.swiper-slide {
    .img-div {
        border-left: 1.5px solid white;
    }
}

.best-deals-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>